import TestingDatePicker from './TestingDatePicker'
import { useState } from 'react'
import TestingSetupActions from './TestingSetupActions'
import { useGetDailyTestingSummaryQuery, useGetMonitoringStatusQuery } from '../services/sessionMonitoringApi'
import { summaryLocalDay } from '../schemas/sessionSummarizers'
import type { TestSession } from '../data/projectTypes'
import SessionSummarizers from './SessionSummarizers'
import './OverviewTestingSummary.css'

export default function OverviewTestingSummary({ projectId, showSetup = true }: {
  projectId: string; runs: TestSession[]; runsLoading: boolean; showSetup?: boolean
}) {
  const [selection, setSelection] = useState<{ projectId: string; day: string } | null>(null)
  const day = selection?.projectId === projectId ? selection.day : undefined
  const query = useGetDailyTestingSummaryQuery({ projectId, day }, { pollingInterval: 30000, skipPollingIfUnfocused: true })
  const monitoring = useGetMonitoringStatusQuery(projectId, { pollingInterval: 30000, skipPollingIfUnfocused: true })
  const summary = query.currentData
  return <>
    {showSetup && <TestingSetupActions key={projectId} projectId={projectId} />}
    <section className="overview-testing" aria-label="Daily testing summary">
      <header className="overview-testing__header">
        <h2>Daily testing summary</h2>
        {summary && <TestingDatePicker day={summary.day} today={summaryLocalDay(summary.timezone)} onChange={day => setSelection({ projectId, day })} />}
      </header>
      {query.isFetching && !summary && <p role="status">Loading daily testing summary…</p>}
      {query.isError && <p role="alert">Could not load the daily testing summary. <button onClick={() => void query.refetch()}>Retry</button></p>}
      {summary && <>
        <p className="overview-testing__summary">{summary.summary ?? 'No testing activity on this day.'}</p>
        {summary.updated_at && <p className="overview-testing__updated">Updated <time dateTime={summary.updated_at}>{new Date(summary.updated_at).toLocaleString()}</time> · {summary.timezone}</p>}
        {monitoring.currentData?.enabled && <details key={`${projectId}:${summary.day}`} className="overview-testing__report">
          <summary>Self-healing daily report · {summary.day}</summary>
          <SessionSummarizers projectId={projectId} day={summary.day} />
        </details>}
      </>}
    </section>
  </>
}
